export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDIAAAAvL8AHABcgFkxwppf/k4ZAIPHJ32WcBQIJRHr7azz/8RcJyKRtarIm57W7I/qfZHfHLA=="